import React, { useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import PropTypes from "prop-types";
import { PieChartSkeleton } from "../Skeleton/Chart";
import { FormatInt } from "../../../utils/FormatData";
ChartJS.register(ArcElement, Tooltip, Legend);
const DoughnutChart = (props) => {
  const {
    title = "",
    loading = false,
    label = "",
    dataSets = [],
    labels = [],
  } = props;

  const generateRandomColor = (length) => {
    const colors = [];
    for (let i = 0; i < length; i++) {
      colors.push(
        `#${(((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0")}`
      );
    }

    return colors;
  };

  const COLORS = useMemo(() => {
    return generateRandomColor(dataSets.length);
  }, [dataSets]);

  const data = {
    labels: labels,
    datasets: [
      {
        label: label,
        data: dataSets,
        backgroundColor: COLORS,
        borderColor: COLORS,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 20,
          usePointStyle: true,
          pointStyle: "circle",
          padding: 10,
          generateLabels: (chart) => {
            let labels = chart.config._config.data.labels.slice(0, 10);
            return labels.map((label, index) => {
              const backgroundColor =
                chart.config._config.data.datasets[0].backgroundColor[index];
              return {
                text: label,
                fillStyle: backgroundColor,
              };
            });
          },
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: "#fff",
        borderColor: "#e5e7eb",
        width: 200,
        borderWidth: 1,
        borderRadius: 8,
        titleColor: "#000",
        bodyColor: "#000",
        callbacks: {
          label: (ctx) => {
            return `SMS: ${FormatInt(ctx.parsed)}`;
          },
        },
      },
    },
  };

  if (loading) return <PieChartSkeleton />;
  return (
    <div className="w-full h-min-64 bg-white px-4 py-2 rounded-lg">
      <div className="text-md font-semibold mb-2">{title}</div>
      <Doughnut data={data} options={options} />
    </div>
  );
};

DoughnutChart.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string,
  dataSets: PropTypes.array,
  labels: PropTypes.array,
  title: PropTypes.string,
};
export default DoughnutChart;
